import type { HttpTransport } from "@common/api/transport";
import type { GardenCrop } from "@common/types";
import type { ID, PaginatedResponse } from "@common/types/api";
import type { GardenCropSimplified } from "@common/types/GardenCrop";

type FetchGardenCropsParams = {
  page?: number;
  limit?: number;
  query?: string;
};

export type UpsertGardenCropParams = Partial<
  Omit<GardenCrop, "cropId" | "cropVarietyId"> & {
    cropId?: string | number;
    cropVarietyId?: null | number | string;
  }
>;

type CopyGardenCropsParams = {
  toGardenId: number;
  fromGardenId: number;
  yearFrom: number;
  yearTo: number;
};

export const createGardenCropsApi = (http: HttpTransport) => ({
  copyGardenCrops: (params: CopyGardenCropsParams) =>
    http.post(`/api/plantings_copies`, { plantingsCopies: params }),

  createGardenCrop: (params: UpsertGardenCropParams) =>
    http.post(`/api/garden_crops`, { gardenCrop: params }),

  fetchGardenCrop: (id: ID) => http.get<GardenCrop>(`/api/garden_crops/${id}`),

  fetchGardenCrops: (params: FetchGardenCropsParams) =>
    http.get<PaginatedResponse<GardenCropSimplified>>("/api/garden_crops", {
      queryParams: params
    }),

  updateGardenCrop: (id: ID, params: UpsertGardenCropParams) =>
    http.patch(`/api/garden_crops/${id}`, { gardenCrop: params })
});
